import React from "react";
import { Container } from "react-bootstrap";
import Cards from "./Card";

const RecentSearch = () => {
  return (
    <>
      <section className="py-4">
        <Container>
          <div>
            <h2 className="head-txt-1 text-start w-100">
              <span>Recent</span> Search
            </h2>
            <div className="row py-3">
              {/* <Cards /> */}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default RecentSearch;
